// Breadcrumbs
export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
export const CLEAR_GROUPS_DETAILS = "CLEAR_GROUPS_DETAILS";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const CLEAR_GROUP_GROUPS = "CLEAR_GROUP_GROUPS";
export const CLEAR_GROUP_IDENTITIES = "CLEAR_GROUP_IDENTITIES";
export const CLEAR_SELECTED_GROUP = "CLEAR_SELECTED_GROUP";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
